import * as React from "react";

export const ModalFailure = ({ children }: React.PropsWithChildren<{}>) => {
    return (
        <>
            <p style={{ fontSize: 100 + 'px' }} className="text-center text-danger">
                <i id="FailureStatus" className="fa fa-times-circle" aria-hidden="true"></i>
            </p>
            <div className="text-center">
                {children}
            </div>
        </>
    );
}
